import { useMemo } from "react";
import { motion } from "framer-motion";

const INITIAL = { opacity: 0, y: 28 };
const IN_VIEW = { opacity: 1, y: 0 };
const VIEWPORT = { once: true, margin: "-60px" };
const EASE = [0.22, 1, 0.36, 1];

export const FadeIn = ({ children, delay = 0, className = "" }) => {
  const transition = useMemo(() => ({ duration: 0.9, delay, ease: EASE }), [delay]);
  return (
    <motion.div
      className={className}
      initial={INITIAL}
      whileInView={IN_VIEW}
      viewport={VIEWPORT}
      transition={transition}
    >
      {children}
    </motion.div>
  );
};
